import React from 'react';
import { CheckIcon } from '../components/Icons.jsx';
import { quizPhase, answerCount } from './quizPhase.js';

/**
 * The quiz buttons as they appear on the projector — a pill floating over
 * the slide. They stay on the projected screen (rather than moving wholesale
 * to the control panel) so that a lesson can still be run from one screen
 * and a presenter remote, the way it was before the control panel existed.
 */
export default function DeckQuizControls({ room, stop }) {
  const phase = quizPhase(room, stop);
  if (phase === 'none') return null;
  const { answered, total } = answerCount(room);

  return (
    <div className="deck-quiz-controls">
      {phase === 'closed' && (
        <button
          className="btn btn-gold deck-quiz-open"
          disabled={room.busy}
          onClick={() => room.actions.openQuestion(stop.order)}
        >
          เปิดให้ตอบ
        </button>
      )}
      {phase === 'open' && (
        <>
          <span className="deck-quiz-status num">ตอบแล้ว {answered}/{total}</span>
          <button className="btn btn-primary" disabled={room.busy} onClick={() => room.actions.reveal()}>
            เฉลย
          </button>
        </>
      )}
      {phase === 'revealed' && (
        <span className="deck-quiz-status is-done">
          <CheckIcon size={15} /> เฉลยแล้ว — กด → เพื่อไปต่อ
        </span>
      )}
    </div>
  );
}
